import { FileText, Library, LogOut } from 'lucide-react';
import type { AdminUser } from '../AdminApp';
import { ChangePasswordPanel } from './ChangePasswordPanel';
import { ContactSubmissionsPanel } from './ContactSubmissionsPanel';

const dashboardCards = [
  {
    title: 'Content',
    description: 'Edit launch copy for public sections as they become CMS-managed.',
    icon: FileText
  },
  {
    title: 'Resources',
    description: 'Manage library records and downloadable PDF metadata backed by R2.',
    icon: Library
  },
];

type DashboardPageProps = {
  user: AdminUser;
  onLogout: () => void;
};

export function DashboardPage({ user, onLogout }: DashboardPageProps) {
  return (
    <>
      <section className="admin-panel login-panel" aria-label="Current admin session">
        <div>
          <p className="eyebrow">Signed In</p>
          <h2>{user.displayName}</h2>
          <p>{user.email}</p>
        </div>
        <div className="admin-form">
          <button className="button-primary" type="button" onClick={onLogout}>
            <LogOut size={18} />
            Log Out
          </button>
        </div>
      </section>
      <ChangePasswordPanel />
      <ContactSubmissionsPanel />
      <section className="admin-dashboard" aria-label="Admin dashboard">
        {dashboardCards.map((card) => {
          const Icon = card.icon;
          return (
            <article className="admin-card" key={card.title}>
              <Icon size={26} />
              <h2>{card.title}</h2>
              <p>{card.description}</p>
            </article>
          );
        })}
      </section>
    </>
  );
}
